import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import EventLocationUpdateChild from "./EventLocationUpdateChild";

import { useLocation } from "react-router-dom";

const EventLocationUpdate = () => {
  let rowdata = useLocation();
  let elocation = rowdata.state;
  return (
    <MainTemplate>
      <CardBackground>
        <EventLocationUpdateChild elocation={elocation} />
      </CardBackground>
    </MainTemplate>
  );
};

export default EventLocationUpdate;
